import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import Select from "react-select";
import * as actions from "../../../../../app/actions/generalActions";
import { FieldFeedbackLabel } from "../../../../_partials/controls";
import { useIntl } from "react-intl";
import { useFilterObjectsUIContext } from "../pages/FilterObjectsUIContext";
import { useFormikContext } from "formik";

export const FilterSelectObjectsField = ({
  api,
  reduxState,
  sname,
  label,
  keyFieldName,
  valueFieldNames,
  useInFilter = true,
  functionName,
  ...props
}) => {
  const objectsUIContext = useFilterObjectsUIContext();
  const objectsUIProps = useMemo(() => {
    return {
      queryParams: objectsUIContext.queryParams,
      setQueryParams: objectsUIContext.setQueryParams,
    };
  }, [objectsUIContext]);

  const { setFieldValue, handleSubmit, errors, touched } = useFormikContext();
  const { field } = props;

  const { currentState } = useSelector(
    (state) => ({ currentState: state[reduxState] }),
    shallowEqual
  );
  const { entities, name } = currentState;
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      actions.fetchSelectObjects(
        api,
        name,
        objectsUIProps.queryParams,
        functionName
      )
    );
  }, [objectsUIProps.queryParams, dispatch]);

  const handleChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
    setFieldValue(field.name, selectedOptions.value);
    if (useInFilter) handleSubmit();
  };

  useEffect(() => {
    var data = [];

    // if (name && name === "filterAnswers")
    //   data.push({ value: 0, label: " بدون پاسخ" })

    // if (name && name !== "filterAnswers" && !label && label !== "")
    //   data.push({ value: 0, label: intl.formatMessage({ id: "SELECT.ALL" }) })

    // if (name && name !== "filterAnswers" && (label || label == ""))
    // data.push({ value: 0, label: intl.formatMessage({ id: "SELECT.ONE" }) })

    if (useInFilter) data.push({ value: 0, label: "همه" });
    else data.push({ value: 0, label: "لطفا انتخاب کنید" });

    if (entities) {
      entities.forEach((element) => {
        data.push({
          value: element[keyFieldName],
          label: element[valueFieldNames],
        });
      });
    }
    setOptions([...data]);
    // if (field.value && data.length > 0) {
    //   var item = data.find(q => q.value === field.value)
    //   setSelectedOptions({ label: item.label, value: field.value })
    // }
    // if (field.value === undefined && field.value === 0 || field.value === [] || field.value === null) {
    //   setSelectedOptions(null)
    // }
    // else {
    //   var item = data.find(q => q.value === field.value)
    //   setSelectedOptions({ label: item.label, value: field.value })
    // }
  }, [entities]);

  useEffect(() => {
    if (options && options.length > 0) {
      if ((field.value === undefined && field.value === 0) || field.value === [] || field.value === null || field.value === undefined) {
        setSelectedOptions(null);
      } else {
        var item = options.find((q) => q.value === field.value);
        setSelectedOptions({ label: item.label, value: field.value });
      }
    }
  }, [options]);

  // const setValue = () => {
  //   if (field.value === 0 || field.value === [] || field.value === null) {
  //     setSelectedOptions(null)
  //   }
  //   else if (field.value && options.length > 0) {
  //     var item = options.find(q => q.value === field.value)
  //     setSelectedOptions({ label: item.label, value: field.value })
  //   }
  // }

  const intl = useIntl();
  return (
    <>
      {label && <label> {label}</label>}
      <Select
        styles={{
          // Fixes the overlapping problem of the component
          menu: (provided) => ({ ...provided, zIndex: 9999 }),
        }}
        // value={() => setValue()}
        value={selectedOptions}
        // defaultValue={selectedOptions}
        name={field.name}
        options={options}
        isMulti={false}
        isSearchable={true}
        // noOptionsMessage={() => "موردی یافت نشد"}
        onChange={handleChange}
        // formatGroupLabel={formatGroupLabel}
        {...props}
      ></Select>
      <FieldFeedbackLabel
        error={errors[field.name] && intl.formatMessage({ id: "YUP.REQUIRED" })}
        touched={touched[field.name]}
        label={label}
        type={field.type}
      />
    </>
  );
};

FilterSelectObjectsField.defaultProps = {
  keyFieldName: "id",
  valueFieldNames: "title",
};

// export const SelectObjectsField = ({
//   api,
//   reduxState,
//   sname,
//   keyFieldName,
//   valueFieldNames,
//   label,
//   ...props
// }) => {
//   const objectsUIContext = useFilterObjectsUIContext();
//   const objectsUIProps = useMemo(() => {
//     return {
//       queryParams: objectsUIContext.queryParams,
//       setQueryParams: objectsUIContext.setQueryParams,
//     };
//   }, [objectsUIContext]);

//   const { currentState } = useSelector(
//     (state) => ({ currentState: state[reduxState] }),
//     shallowEqual
//   );
//   const { entities, name } = currentState;

//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(actions.fetchSelectObjects(api, name, objectsUIProps.queryParams));
//   }, [objectsUIProps.queryParams, dispatch]);

//   const intl = useIntl();
//   return (
//     <>
//       <Select name={sname} label={label} {...props}>
//         {name && name === "filterAnswers" && (
//           <option key={0} value={0}>
//             بدون پاسخ
//           </option>
//         )}
//         {name !== "filterAnswers" && !label && label !== "" && (
//           <option key={0} value={0}>
//             {intl.formatMessage({ id: "SELECT.ALL" })}
//           </option>
//         )}
//         {name !== "filterAnswers" && (label || label == "") && (
//           <option key={0} value={0}>
//             {intl.formatMessage({ id: "SELECT.ONE" })}
//           </option>
//         )}
//         {entities &&
//           entities.map((entity, index) => {
//             const valueField = valueFieldNames
//               .map((val) => entity[val])
//               .join(" ");

//             return (
//               <option key={entity[keyFieldName]} value={entity[keyFieldName]}>
//                 {valueField}
//               </option>
//             );
//           })}
//       </Select>
//     </>
//   )
// }

// SelectObjectsField.defaultProps = {
//   keyFieldName: "id",
//   valueFieldNames: ["title"],
// };
